import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { ReservationCompare } from '../models/reservation-compare';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../http/app.auth.http.service';

@Injectable()
export class ReservationCompareService {

  private eventUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  get(eventId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getReservations(eventId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/reservations/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getReservationsByParty(eventId: number, eventPartyId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/${eventPartyId}/reservations/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getRsvps(eventId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/rsvps/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getRsvpsByParty(eventId: number, eventPartyId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/${eventPartyId}/rsvps/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getReservationsAndRsvps(eventId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/reservations/rsvps/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getReservationsAndRsvpsByParty(eventId: number, eventPartyId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/${eventPartyId}/reservations/rsvps/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/reservation-compare-http-service.ts